import React from "react";
import { Col, Form, FormCheck, Row } from "react-bootstrap";
import { ErrorMessage } from "formik";

interface TaskAdditionalFieldsProps {
  errors: any;
  touched: any;
  handleChange: (e: React.ChangeEvent<any>) => void;
  values: any;
}

export const TaskAdditionalFields: React.FC<TaskAdditionalFieldsProps> = ({
  errors,
  touched,
  handleChange,
  values,
}) => (
  <>
    <Form.Group as={Row} className="mb-3" controlId="taskNotes">
      <Form.Label column sm={3}>
        Notes
      </Form.Label>
      <Col sm={9}>
        <Form.Control
          as="textarea"
          name="notes"
          onChange={handleChange}
          className={"form-control" + (errors.notes && touched.notes ? " is-invalid" : "")}
        />
        <ErrorMessage name="notes" component="div" className="invalid-feedback" />
      </Col>
    </Form.Group>

    <Form.Group as={Row} className="mb-3" controlId="taskAddToCalendar">
      <Form.Label column sm={3}>
        Add to Calendar
      </Form.Label>
      <Col sm={9}>
        <FormCheck
          type="switch"
          id="custom-switch"
          label=""
          checked={values.addToCalendar}
          onChange={handleChange}
          name="addToCalendar"
        />
      </Col>
    </Form.Group>
  </>
);
